import fetchMerchandiseTopBrands from 'actions/merchandise/fetchMerchandiseTopBrands'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { EmptyArray } from 'lib/array/arrayUtils'
import { useEffect } from 'react'

type ReturnType = [
  Array<App.MerchandiseBrand>,
  boolean,
  any,
]

function useMerchandiseTopBrands(): ReturnType {
  const dispatch = useAppDispatch()

  const topBrands = useAppSelector(state => state.merchandise.merchandiseTopBrands)
  useEffect(() => {
    dispatch(fetchMerchandiseTopBrands())
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return [
    topBrands?.brands ?? EmptyArray,
    topBrands?.fetching ?? false,
    topBrands?.error,
  ]
}

export default useMerchandiseTopBrands
